<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Últimas Faturas</h3>
        </div>
        <div class="col text-right">
          <a href="#!" class="btn btn-sm btn-primary">Ver Todas</a>
        </div>
      </div>
    </div>

    <el-table class="table-responsive table" :data="tableData" header-row-class-name="thead-light">
      <el-table-column label="Unidade" sortable min-width="130px" prop="page">
        <template v-slot="{row}">
          <div class="font-weight-600">{{row.page}}</div>
        </template>
      </el-table-column>
      <el-table-column label="Data" sortable min-width="70px" prop="visitors"></el-table-column>
      <el-table-column label="Vencimento" sortable min-width="90px" prop="unique"></el-table-column>
      <el-table-column label="Valor" sortable min-width="90px" prop="valor"></el-table-column>
      <el-table-column label="Status" sortable min-width="90px" prop="bounceRate">
        <template v-slot="{row}">
          <i
            class="fas fa-arrow-down text-success mr-3"
            :class="row.bounceRateDirection === 'up' ? 'text-success': 'text-danger'"
          ></i>
          {{row.bounceRate}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "ultimasFaturas",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      tableData: [
        {
          page: "1323231 ",
          visitors: "10/10/2020",
          unique: "20/10/2020",
          bounceRate: "",
          bounceRateDirection: "down",
          valor: "R$ 1823,00"
        },
        {
          page: "23324323",
          visitors: "10/11/2020",
          unique: "20/10/2020",
          bounceRate: "",
          bounceRateDirection: "down",
          valor: "R$ 232,00"
        },
        {
          page: "23342232",
          visitors: "11/03/2020",
          unique: "20/10/2020",
          bounceRate: "",
          bounceRateDirection: "down",
          valor: "R$ 533,00"
        },
        {
          page: "2323323",
          visitors: "10/10/2020",
          unique: "20/10/2020",
          bounceRate: "",
          bounceRateDirection: "down",
          valor: "R$ 432,00"
        }
      ]
    };
  }
};
</script>
<style>
</style>
